/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModuleContent_bottomModule = ReadonlyArray<{
    readonly title: string | null;
    readonly description: string | null;
    readonly " $refType": "SharedBottomModuleContent_bottomModule";
}>;
export type SharedBottomModuleContent_bottomModule$data = SharedBottomModuleContent_bottomModule;
export type SharedBottomModuleContent_bottomModule$key = ReadonlyArray<{
    readonly " $data"?: SharedBottomModuleContent_bottomModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedBottomModuleContent_bottomModule">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedBottomModuleContent_bottomModule",
  "type": "BottomModule",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '5c394bfcb2e03f15abfc2623193c3bac';
export default node;
